/*
 * Model for Tableau ad-hoc workbooks
 */
define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Messenger, Properties, SortableListModel) {
  var AdHocWorkbooksModel = {};

  AdHocWorkbooksModel.workbook = Backbone.Model.extend({
    idAttribute: "workbookId",
    defaults: {
      name: "",
      contentUrl: "",
    },
    defaultValidateAttributes: ["name"],
    _validateDuplicateWorkbookName: function (value) {
      if (this.collection) {
        let duplicateName = false;
        this.collection.each(function (workbook) {
          //check if the other object has the same name (ignore case) and is actually a different object
          if (
            workbook.get("name").toLowerCase() === value.toLowerCase() &&
            workbook.cid !== this.cid
          ) {
            duplicateName = true;
          }
        }, this);
        if (duplicateName) return $.t("reports.adHoc.workbooks.uniqueMessage");
      }
    },
    validateAttribute: function (attribute, value) {
      if (attribute === "name") {
        return (
          this.validateRequiredValue(value, { maxLength: 255 }) ||
          this.validateSafeCharacters(value) ||
          this._validateDuplicateWorkbookName(value)
        );
      }
    },
  });

  AdHocWorkbooksModel.workbooks = Backbone.Collection.extend({
    model: AdHocWorkbooksModel.workbook,
    addItem: function () {
      var newItem = new AdHocWorkbooksModel.workbook();
      this.add(newItem);
      return newItem;
    },
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "name");
    },
    url: function () {
      var kbModel = Messenger.reqres.request("active:kb:model");
      var tenant = Messenger.reqres.request("active:tenant");
      var username = tenant.get("tableauUser");
      return (
        Properties.rootURL +
        "/" +
        kbModel.get("kbId") +
        "/reports/adhoc/site/" +
        kbModel.get("tenantId") +
        "/user/" +
        username +
        "/workbooks"
      );
    },
  });

  Messenger.reqres.setHandler(
    "adHoc:workbooks",
    function () {
      var workbooks = new AdHocWorkbooksModel.workbooks();
      workbooks.fetch();
      return workbooks;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "adHoc:workbook:headers",
    function () {
      var Header = SortableListModel.headerModel;
      var headerArr = [];
      var isAdHocAdmin = Messenger.reqres.request("user:is:adhoc:admin");

      headerArr.push(
        new Header({
          headerName: $.t("reports.adHoc.workbooks.name"),
          modelAttribute: "name",
          selectable: true,
          sortable: true,
          filterable: false,
        }),
      );
      if (isAdHocAdmin) {
        headerArr.push(
          new Header({
            headerName: "",
            modelAttribute: "name",
            width: "15px",
            customHtml:
              '<button id="deleteWorkbook" type="button" class="btn btn-danger btn-mini" data-toggle="tooltip" data-i18n="[title]reports.adHoc.workbooks.deleteWorkbook"> \n\
               <i class="icon-remove"></i> \n\
             </button>',
          }),
        );
      }
      var headerCol = new Backbone.Collection(headerArr);
      return headerCol;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "adHoc:workbook:url",
    function (selectedWorkbook) {
      var workbookUrlModel = new Backbone.Model();
      workbookUrlModel.url = function () {
        return selectedWorkbook.url() + "/url";
      };
      workbookUrlModel.fetch({
        error: function (model, response) {
          Messenger.showErrorFromResponse(response);
        },
      });
      return workbookUrlModel;
    },
    this,
  );

  return AdHocWorkbooksModel;
});
